import React from 'react';
import classNames from 'classnames';
import InputLabel from '../InputLabel/InputLabel';
import InputError from '../InputError/InputError';
import { DAYS_IN_MONTH } from 'constants/date';

export default function MonthDaySelector({
  label,
  value = [],
  onChange,
  error,
  className = '',
}) {
  const days = Array.from({ length: DAYS_IN_MONTH }, (_, i) => i + 1);

  const toggleDay = (day) => {
    const newValue = value.includes(day)
      ? value.filter(d => d !== day)
      : [...value, day];
    onChange(newValue);
  };

  return (
    <div className={className}>
      {label && <InputLabel className="mb-2">{label}</InputLabel>}
      <div className="grid grid-cols-7 gap-4 sm:grid-cols-10">
        {days.map((day) => {
          const isSelected = value.includes(day);
          return (
            <button
              key={day}
              type="button"
              onClick={() => toggleDay(day)}
              className={classNames(
                "flex h-8 w-8 items-center justify-center rounded text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 focus:ring-offset-gray-900 cursor-pointer",
                isSelected
                  ? "bg-indigo-600 text-white hover:bg-indigo-500"
                  : "bg-white/5 text-gray-400 hover:bg-white/10 hover:text-white ring-1 ring-inset ring-white/10"
              )}
            >
              {day}
            </button>
          );
        })}
      </div>
      {error && <InputError className="mt-2">{error}</InputError>}
    </div>
  );
}
